import React, { Component } from "react";
import { Row, Col, Card, Button, Empty } from "antd";
import Category from "../../components/CategoriesCard";
import { connect } from "react-redux";
import { CatalogAction } from "../../store/actions";
import General_Info from "../../components/generalInfo";
import RMX from "../../assets/images/b-RMX-1.png";
import "./Styles.css";
import CoverImage from "../../components/coverImage";
import ProductCard from "../../components/productCard";
const assets = JSON.parse(localStorage.getItem("assets"));
class StorePreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categoryName: "Standard Products",
      productsState: [],
    };
  }

  abc = (key) => {
    const ab = this.props.products.filter((item) => {
      return item.category_id == key.id;
    });
    this.setState({
      productsState: ab,
    });
  };

  componentDidMount() {
    const { getCategories } = this.props;
    getCategories();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const filterCategories = (nextProps.categories || []).filter((item) => {
      return nextProps.products.some((v) => {
        return v.category.id == item.id;
      });
    });
    const filterPro = nextProps.products.filter((item) => {
      return item.category.id === filterCategories?.[0]?.id;
    });
    this.setState({
      productsState: filterPro,
    });
  }

  render() {
    if (this?.props?.location?.state?.fromCustom) {
      return <General_Info />;
    }
    const filterCategories = (this.props.categories || []).filter((item) => {
      return this.props.products.some((v) => {
        return v.category.id == item.id;
      });
    });
    console.log("product==>", this.props.products);
    console.log("companyDetails==>", assets);
    // const { companyDetails } = this.props;
    return (
      <Row>
        <Col xl={24} lg={24} xs={24} sm={24} md={24}>
          <Card>
            <Row>
              <Col
                span={12}
                style={{
                  padding: "15px",
                }}
              >
                <img
                  src={RMX}
                  style={{
                    width: "60%",
                    maxWidth: "100%",
                    height: "auto",
                    // position: "absolute",
                    backgroundRepeat: "no-repeat",
                    top: "-20px",
                  }}
                />
              </Col>
            </Row>
            <Row justify="center">
              <Col span={19}>
                <CoverImage
                  isShowEditCoverImage={true}
                  isShowProfileIcon={true}
                  isShowProfileName={true}
                  userImage={assets.logo?.original}
                  CoverImage={assets.cover?.original}
                />
              </Col>
            </Row>
            <Row justify="center">
              <Col xl={20}>
                <Row>
                  <Col span={24}>
                    {" "}
                    <h6 className="text-left catalog-heading-register">
                      Store Preview
                    </h6>
                  </Col>
                  <Col xl={6} lg={8} xs={24} sm={24} md={8}>
                    <Category
                      abc={this.abc}
                      categorey={filterCategories}
                      isImageTrue={true}
                      StorePreview
                      {...this.props}
                    />
                  </Col>
                  <Col xl={18} lg={8} xs={24} sm={24} md={8}>
                    <Row>
                      {this.state.productsState.length || [] ? (
                        this.state.productsState.map((item) => {
                          return (
                            <Col xl={8} lg={8} md={6} xs={24} sm={24}>
                              <ProductCard
                                // fromNewCatalog={fromNewCatalog}
                                data={item}
                                // onAdd={(e) => {
                                //   setConfigModal(true);
                                //   setProductId(item.id);
                                //   setProduct(item);
                                //   onOpenModal(item.price);
                                // }}
                                // onConfigure={(e) => {
                                //   setConfigModal(true);
                                //   setProductId(item.id);
                                //   setProduct(item);
                                //   onOpenModal(item.price);
                                // }}
                                // onDeactive={(e) => {
                                //   setIsOpenModal(true);
                                //   setProductId(item.id);
                                //   setProduct(item);
                                // }}
                              />
                            </Col>
                          );
                        })
                      ) : (
                        <Col span={24}>
                          {/* {isLoading && (
                            <img src={LoaderGif} height={"60"} width={"60"} />
                          )}
                          {!isLoading && (
                        )} */}
                          <Empty description={"Nothing to show right now."} />
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card>
          <Row justify="center ">
            <Col span={18}>
              <Row justify="end">
                <Col xl={10} xs={12} sm={12} md={6} lg={5}>
                  <Button
                    style={{
                      backgroundColor: "#26a69a",
                      color: "#fff",
                      width: "50%",
                    }}
                    onClick={() => this.props.onChangePreview()}
                  >
                    ADD MORE PRODUCTS
                  </Button>
                  <Button
                    style={{
                      backgroundColor: "#ff9800",
                      color: "#fff",
                      width: "50%",
                    }}
                    onClick={() => alert("HEllO")}
                  >
                    CONTINUE
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    categories: store.CatalogReducer.categories,
    companyDetails: store.UserReducer.companyDetails,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCategories: (params) => dispatch(CatalogAction.getCategoriesReq(params)),
    // getCompanyDetails: () => dispatch(UserAction.getCompantDetailReq()),
    getProducts: (params, isTrue) =>
      dispatch(CatalogAction.getProductReq(params, isTrue)),
    updateShippingCost: (value, id) =>
      dispatch(CatalogAction.updateShipingCostReq(value, id)),
    getShippingCost: () => dispatch(CatalogAction.getShipingCostReq()),
    updateProduct: (value, id, active) =>
      dispatch(CatalogAction.updateProductReq(value, id, active)),
    postProduct: (payload) => dispatch(CatalogAction.postProductReq(payload)),
    basemixdata: (params) =>
      dispatch(CatalogAction.getBasemixCategoriesReq(params)),
    getbasemixes: (params) => dispatch(CatalogAction.getBasemixesReq(params)),
    getadditives: (params) => dispatch(CatalogAction.getAdditivesReq(params)),
    getbasemixesCategories: (params) =>
      dispatch(CatalogAction.getBasemixesCategoriesReq(params)),
    getTemplate: (params) => dispatch(CatalogAction.getTemplateReq(params)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StorePreview);
